import React from 'react';
import { useTranslate, usePermissions } from 'react-admin';
import FullscreenDrawer from '~/components/FullscreenDrawer';
import { EditForm } from '~/components/ra';
import ScriptForm from './ScriptForm';
import { Script } from '~/types/scripts';
import { createOnError } from '~/errorsHandler';

interface Props {
  record: Script | null;
  onClose: () => void;
}

const ScriptEdit: React.FC<Props> = (props) => {
  const { record, onClose } = props;
  const translate = useTranslate();
  const t = (key: string): string => translate(`resources.scripts.fields.${key}`);
  const { permissions } = usePermissions();

  if (!record) return null;

  return (
    <FullscreenDrawer heading={t('editScript')} open={!!record} onClose={onClose}>
      <EditForm
        resource='scripts'
        onError={createOnError(true)}
        closeParent={onClose}
        record={record}
        disabled={!permissions?.includes('script.update')}
        style={{ width: '100%', padding: 28, paddingTop: 0 }}
      >
        <ScriptForm />
      </EditForm>
    </FullscreenDrawer>
  );
};

export default ScriptEdit;
